import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useNavigate } from "react-router-dom";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { tasksId } from "../../../types/activityTasks";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { ModalResultFinalTopic } from "../../../components/common/ModalResultFinalTopic";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { audiosAssets } from "../../../assets/audio";

const steps = {
	initialDialog: 1,
	final: 2,
};

export const Theme3SubtopicOneFinalPoints = () => {
	const navigator = useNavigate()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points, statusTopic } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema3.activities.subtema1]);
	const [uiToShow, setUiToShow] = useState(steps.initialDialog);

	useEffect(() => {
		if (loaded) {
			console.log("theme 3 sub 1 final");
			ObserverEmitter.emit(EVENTS.tema3.actOne.initScene, 6);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
			</>

			{uiToShow === steps.initialDialog && (
				<>
					<ModalResultFinalTopic
						title={statusTopic === 2 ? "¡Bien hecho!" : "¡Oh¡ no"}
						subTitle={
							statusTopic === 2
								? "¡Felicidades! has completado el Subtema 1."
								: "No has conseguido los puntos necesarios para la insignia, suerte para la próxima."
						}
						buttonText={statusTopic === 2 ? "Continuar" : "Siguiente"}
						statusModal={statusTopic}
						points={points}
						actionButton={() => {
							setUiToShow(steps.final);
						}}
					/>
				</>
			)}

			{uiToShow === steps.final && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 1: Ejecución de panera y quesera"
						titleActivity="Actividades realizadas:"
						points={points}
						insigniaBackground={statusTopic}
						actionButton={() => {
							navigator("/home3/tema3/subtema2/activityOne");
						}}
						activities={tasksList}
					/>
				</>
			)}
		</>
	);
};
